<form [formGroup]="form">
  <app-form-control label="Data wydania">
    <p-date-picker
      [formControl]="form.controls.releasedAt"
      placeholder="Wybierz datę wydania" />
  </app-form-control>

  <div class="rounded-lg border border-gray-200 p-4">
    <p-accordion
      [multiple]="true"
      [value]="activeProductIndex">
      @for (
        productFormGroup of getProductFormGroups();
        track productFormGroup;
        let index = $index, count = $count
      ) {
        <app-warehouse-release-form-product-panel
          [productFormGroup]="productFormGroup"
          [total]="count"
          [index]="index"
          (removeClickEvent)="handleProductRemoveClick($event)" />
      }
    </p-accordion>

    <div class="mt-4 flex justify-end">
      <p-button
        (onClick)="handleProductAddClick()"
        appPrimengButton
        label="Dodaj produkt" />
    </div>
  </div>

  <div class="mt-4">
    <app-form-control label="Komentarz">
      <textarea
        [formControl]="form.controls.comment"
        appPrimengTextarea
        pTextarea
        placeholder="Wprowadź komentarz"
        rows="5"></textarea>
    </app-form-control>

    @if (fileUploadVisibility()) {
      <app-warehouse-files-upload [formControl]="form.controls.fileIds" />
    }
  </div>

  <div class="flex justify-end">
    <p-button
      (onClick)="handleSubmitClick()"
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      severity="primary"
      type="submit" />
  </div>
</form>
